import { Karte } from '../komponenten/Karte'

/* Ein nicht gebuchtes Werkzeug.
 *
 * Der Knopf bleibt bedienbar und führt hierher statt ins Leere. Wer
 * nicht weiß, was hinter dem Schloss liegt, fragt auch nicht danach —
 * deshalb steht hier, was das Werkzeug kann, und nicht nur, dass es
 * fehlt. Drei Sätze, keine Verkaufsseite.
 */

type Werkzeug = 'reporting' | 'audit'

const TEXTE: Record<Werkzeug, {
  name: string; satz: string; punkte: { was: string; wie: string }[]
}> = {
  reporting: {
    name: 'Reporting',
    satz: 'Das Reporting wertet aus, was die Kasse ausgegeben hat: '
      + 'Umsatz, Artikel, Gäste und Tische — je Tag, im Verlauf und '
      + 'über alle Standorte nebeneinander.',
    punkte: [
      { was: 'Tag und Verlauf',
        wie: 'Umsatz, Rechnungen, Durchschnittsrechnung und Stundenverlauf '
           + 'eines Geschäftstags — und dieselben Größen über Wochen.' },
      { was: 'Artikel und Zusammenstellungen',
        wie: 'Was verkauft wurde, und woraus ein Gericht bestand: '
           + 'Größenwahl, Beilage, Dip.' },
      { was: 'Gäste, Tische, Standorte',
        wie: 'Verweildauer, Umsatz je Gast, Auslastung — und der '
           + 'Vergleich zwischen den Häusern.' },
    ],
  },
  audit: {
    name: 'Audit',
    satz: 'Das Audit setzt jede Rechnung aus den Kassendaten neu '
      + 'zusammen und vergleicht sie mit dem, was die Kasse '
      + 'ausgewiesen hat.',
    punkte: [
      { was: 'Rechnungsprüfung',
        wie: 'Der Abgleich Tag für Tag: Soll gegen Ist, mit Befund und '
           + 'Schweregrad — und dem Katalog dessen, wonach gesucht '
           + 'wurde.' },
      { was: 'Stornos mit Personenbezug',
        wie: 'Wer storniert hat, wie oft, für wen und nach welcher '
           + 'Wiedereröffnung. Im Reporting wird das nicht einmal '
           + 'abgefragt.' },
      { was: 'Auffälligkeiten statt Verdacht',
        wie: 'Gezählt wird, was messbar ist. Was daraus folgt, '
           + 'entscheidet das Haus.' },
    ],
  },
}

export function Gesperrt({ werkzeug }: { werkzeug: Werkzeug }) {
  const t = TEXTE[werkzeug]
  return (
    <Karte titel={`${t.name} ist nicht gebucht`} neben="was dahinter liegt">
      <p style={{ maxWidth: '66ch', lineHeight: 1.7, marginTop: 4 }}>
        {t.satz}
      </p>
      <div style={{ marginTop: 4 }}>
        {t.punkte.map((p) => (
          <div className="punkt" key={p.was}>
            <span className="marke">{p.was}</span>
            {p.wie}
          </div>
        ))}
      </div>
      <p className="dezent" style={{
        fontSize: 12, lineHeight: 1.7, marginTop: 16, marginBottom: 4,
        maxWidth: '66ch',
      }}>
        Freischalten lässt sich das Werkzeug über Ihre Betreuung.{' '}
        {werkzeug === 'audit'
          ? 'Die Kassendaten sind vorhanden; die Prüfungen für den gewählten Zeitraum müssen danach noch laufen.'
          : 'Bereits eingelesene Kassendaten bleiben erhalten.'}
      </p>
    </Karte>
  )
}
